import { Component } from '@angular/core';
import { MdcService } from 'src/app/shared/mdc/mdc.service';
import { PaisService } from 'src/app/shared/pais/pais.service';

@Component({
  selector: 'app-step-section-i',
  templateUrl: './step-section-i.component.html',
})
export class StepSectionIComponent {
  constructor(public paisService: PaisService, public mdcService: MdcService) { }
}